// extracted by mini-css-extract-plugin
export var allNePasManquer = "ne-pas-manquer-module--all-ne-pas-manquer--dd562";
export var editButtonTitle = "ne-pas-manquer-module--edit-button-title--6ac17";
export var nePasManquerContainer = "ne-pas-manquer-module--ne-pas-manquer-container--394bf";
export var nePasManquerItem = "ne-pas-manquer-module--ne-pas-manquer-item--eab9e";
export var nePasManquerItemContainer = "ne-pas-manquer-module--ne-pas-manquer-item-container--5da36";
export var nePasManquerItemDescription = "ne-pas-manquer-module--ne-pas-manquer-item-description--b732f";
export var nePasManquerResume = "ne-pas-manquer-module--ne-pas-manquer-resume--941e2";
export var nePasManquerTitle = "ne-pas-manquer-module--ne-pas-manquer-title--405ea";
export var nePasManquerWrapper = "ne-pas-manquer-module--ne-pas-manquer-wrapper--ab185";